// import Vue from 'vue'
// import locale from 'element-ui/lib/locale';
// import VueI18n from 'vue-i18n'
// import messages from './langs'
// Vue.use(VueI18n)


// //从localStorage中拿到用户的语言选择，如果没有，那默认中文。
// const i18n = new VueI18n({
//     locale: languageKey,
//     messages,
// })
// locale.i18n((key, value) => i18n.t(key, value)) //为了实现element插件的多语言切换

// export default i18n

import Vue from 'vue'
import locale from 'element-ui/lib/locale';
import VueI18n from 'vue-i18n'
import messages from './langs/index'
Vue.use(VueI18n)
let languageKey = sessionStorage.getItem('language');



if(languageKey){
    if (languageKey === 'en_US') {
        languageKey = 'enUS';
    } else if(languageKey === 'zh_CN') {
        languageKey = 'zhCN';
    }
}else{
    languageKey = 'zhCN';
}

// if (languageKey != null) {
//     if (languageKey === 'en_US') {
//         languageKey = 'enUS';
//     } else if(languageKey === 'zh_CN') {
//         languageKey = 'zhCN';
//     }
// } else {
//     languageKey = 'en_US';
//     localStorage.setItem('language', 'en_US');
// }

const i18n = new VueI18n({
  locale: languageKey,
  messages
})
locale.i18n((key, value) => i18n.t(key, value)) //为了实现element插件的多语言切换

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/i18n.js